import React, { Component } from 'react';
import Slider from '~/js/components/global/Slider';

const internals = {};

internals.resortsInfo = {
  BTC: {
    location: 'Providenciales, Turks & Caicos',
    description: "<span class=\"bold\">A true island escape set on 12 miles of the world's best beach,</span> <a href=\"/resorts/turks-caicos/\" class=\"blue\">Beaches Turks & Caicos</a> is the ultimate all-inclusive vacation for families. With endless land and water sports, <a href=\"/resorts/turks-caicos/restaurants/\" class=\"blue\">Global Gourmet dining at 19 restaurants</a>, luxurious rooms and suites, and exciting family-friendly activities including Sesame Street<sup>®</sup> stage shows, the <a href=\"/resorts/turks-caicos/activities/waterpark/\" class=\"blue\">Caribbean's most thrilling waterpark</span, and fantastic beach parties, it's easy to see why Beaches Turks & Caicos has been voted Top 25 Hotels for Families in the World by tripadvisor<sup>®</sup> year after year."
  },
  BNG: {
    location: 'negril, jamaica',
    description: "<span class=\"bold\">Negril invented \"chill\" - so get ready to embrace the laid-back spirit</span> at this low-rise resort perched along Jamaica's famed <a href=\"/resorts/negril/7-mile-beach/\" class=\"blue\">Seven Mile Beach.</a> From the moment you enter the open-air lobby you'll be caught up by fresh ocean breezes and the vibrant colors of the West Indies. Bringing the outside in, this all inclusive resort and <a href=\"/resorts/negril/rooms/\" class=\"blue\">spa</a> in Negril, <a href=\"/jamaica/\" class=\"blue\">Jamaica</a> is always open to the breathtaking beauty of the tropics. The vibe here is totally carefree and about spending time with those you love."
  },
  BBO: {
    location: 'Ocho rios, jamaica',
    description: "<span class=\"bold\">Voted among the Top 10 Best Beach Resorts by Parents magazine.</span> Twenty-two acres of lush tropical gardens, a gorgeous private white-sand beach, <a href=\"/resorts/ocho-rios/restaurants/\" class=\"blue\">6 gourmet restaurants</a>, 3 fantastic swimming pools, a dedicated <a href=\"/scuba/\" class=\"blue\">scuba</a> practice pool and an entire ocean of <a href=\"/activities/watersports/\" class=\"blue\">watersports</a> are just a few of the places and things to explore. Plus, only at <a href=\"/resorts/ocho-rios/\" class=\"blue\">Beaches Ocho Rios</a>, families can meet Oscar, the resident Grouch from <a href=\"/activities/sesame-street/\" class=\"blue\">Sesame Street<sup>®</sup></a>, and participate in the From Trash to Treasure activity and join in at Oscar's Sing-A-Long pre-show... all part of the Beaches Resorts' Caribbean Adventure with Sesame Street<sup>®</sup>."
  }
};

export default class ResortInfo extends Component {

  componentDidMount() {
    const descBoxes = [...document.querySelectorAll('.view-book-info-content')];

    if (window.innerWidth < 768 && descBoxes.length) {
      descBoxes.map(box => {
        const descText = box.querySelector('h4');
        const triggerButton = box.querySelector('.read-more');

        const countLines = () => {
          const divHeight = descText.offsetHeight;
          const lineHeight = parseInt(window.getComputedStyle(descText).lineHeight, 0);

          return divHeight / lineHeight;
        };

        if (countLines() < 5) {
          descText.classList.add('expanded');
          triggerButton.classList.add('hide');
        }
      });
    }
  }

  render() {
    const { resortSummary, cdnURL } = this.props;
    const rstName = resortSummary.resortShortName.replace('Beaches ', '');
    const rstURL = `/resorts/${rstName.replace(/(\s&\s)|\s/g, '-').toLowerCase()}/`;

    const showText = (e) => {
      let target = e.target;
      let text = target.parentElement.querySelector('h4');

      if (e.target.tagName !== 'SPAN') {
        target = e.target.parentElement;
        text = target.parentElement.querySelector('h4');
      }

      text.classList.toggle('expanded');
      target.classList.toggle('expanded');
    };

    return (
      <div className="view-book-info row">
        <div className="view-book-info-slider xs-12 lg-5 xl-4">
          <Slider cdnURL={cdnURL} resortSummary={resortSummary} rstURL={rstURL} sliderData={beaches_app.page.sliderData}/>
          <a href={rstURL}>View Resort Details</a>
        </div>
        <div className="view-book-info-content xs-12 lg-7 xl-8">
          <div className="txt-center">
            <i className="ic icon-new-logo-beaches" />
            <h3>{rstName}</h3>
            <p>{internals.resortsInfo[resortSummary.rstCode].location}</p>
          </div>
          <h4 dangerouslySetInnerHTML={ {__html: `${internals.resortsInfo[resortSummary.rstCode].description}`} } />
          <span onClick={(e) => {showText(e);}} className="read-more"><i className="icon-reading"/></span>
        </div>
      </div>
    );
  }
}
